import { getPincodeMaster } from "../services/serviceCollections/pincodeService";
import { showMessage } from "./toastMessageUtil";

const BLOCKED_PINCODES = ["400000"];

export const handlePincodeLookup = async ({ pincode, isUserNRI, isUserFN, type, updateValue, setLoading }) => {
  if (isUserNRI) {
    return { success: false, allowManual: true };
  }

  if (isUserFN) {
    return { success: false, allowManual: true };
  }

  if (!pincode || pincode.length < 6) {
    return { success: false, allowManual: true };
  }

  if (BLOCKED_PINCODES.includes(pincode)) {
    showMessage("error", "This Pin Code is not serviceable. Please enter a valid Pin Code.");

    clearFields(type, updateValue);

    if (type === "residence") {
      updateValue("pincodeResidence", "");
    } else if (type === "work") {
      updateValue("pincodeWork", "");
    }

    return { success: false, allowManual: false };
  }

  try {
    setLoading?.(true);

    const result = await getPincodeMaster(pincode);
    // console.log("result await pincode master", result);

    const states = Array.isArray(result?.stateName) ? result.stateName : [];
    const cities = Array.isArray(result?.cityName) ? result.cityName : [];

    //  Group cities by state
    const stateMap = {};

    for (let i = 0; i < states.length; i++) {
      const state = states[i];
      const city = cities[i];

      if (!state || !city) continue;

      const cleanState = state.trim();
      const cleanCity = city.trim();

      if (!stateMap[cleanState]) {
        stateMap[cleanState] = new Set();
      }

      stateMap[cleanState].add(cleanCity);
    }

    const groupedStates = Object.keys(stateMap).map((state) => ({
      state,
      cities: Array.from(stateMap[state]),
    }));

    //  No valid results
    if (groupedStates.length === 0) {
      showMessage("warning", "We are currently unable to fetch City & State for the entered Pin Code. Please re-check / enter the details manually.");

      clearFields(type, updateValue);
      return { success: false, allowManual: true };
    }

    //  🚨 NEW RULE → MULTIPLE STATES = HARD FAIL
    if (groupedStates.length > 1) {
      showMessage("warning", "We are currently unable to fetch City & State for the entered Pin Code. Please re-check / enter the details manually.");

      clearFields(type, updateValue);
      return { success: false, allowManual: true };
    }

    //  ONLY 1 STATE FROM HERE
    const singleState = groupedStates[0];

    //  Single state + single city → autofill
    if (singleState.cities.length === 1) {
      const city = singleState.cities[0];
      autofillFields(type, singleState.state, city, updateValue);

      return {
        success: true,
        allowManual: false,
        state: singleState.state,
        city,
      };
    }

    //  Single state + multiple cities → dropdown
    return {
      success: true,
      multipleOptions: true,
      data: singleState, // SAME AS BEFORE
    };
  } catch (error) {
    console.error("Pincode lookup failed", error);

    showMessage("warning", "We are currently unable to fetch City & State for the entered Pin Code. Please re-check / enter the details manually.");

    clearFields(type, updateValue);
    return { success: false, allowManual: true };
  } finally {
    setLoading?.(false);
  }
};

/* ---------------- Helpers ---------------- */

const clearFields = (type, updateValue) => {
  if (type === "residence") {
    updateValue("stateResidence", "");
    updateValue("cityResidence", "");
  } else if (type === "work") {
    updateValue("stateWork", "");
    updateValue("cityWork", "");
  }
};

const autofillFields = (type, state, city, updateValue) => {
  if (type === "residence") {
    updateValue("stateResidence", state);
    updateValue("cityResidence", city);
  } else if (type === "work") {
    updateValue("stateWork", state);
    updateValue("cityWork", city);
  }
};
